import { Component, OnInit, ChangeDetectionStrategy, input } from '@angular/core';
import { Content } from '../../../../domain/content/content.model';
import { UrlCleanPipe } from '../../../util/pipes/url-clean/url-clean.pipe';
import { NgClass, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'dottnet-standard-card',
  templateUrl: 'standard-card.component.html',
  styleUrls: ['standard-card.component.scss'],
  imports: [MatCardModule, RouterLink, NgClass, DatePipe, UrlCleanPipe, MatIconModule]
})
export class StandardCardComponent {
  readonly content = input<Content>(undefined);
  // Switch from space-evenly to space-between in template (title + subtitle)
  readonly isHomeCard = input<boolean>(false);

  constructor() { }
}
